import React, { useEffect, useState } from "react";

import { API, graphqlOperation } from "aws-amplify";
import { updateLocation } from "../../../graphql/mutations";
import {
  getAisle,
  locationByAisleBySortKey,
} from "../../../graphql/reloadyard/custom-queries";
import {
  inventoryItemByAisleByStatusLookup,
  inventoryItemByLocationByStatus,
} from "../../../graphql/inventory/custom-queries";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Slider,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import SpeedIcon from "@material-ui/icons/Speed";
import { blueGrey, green, deepOrange } from "@material-ui/core/colors";
import {
  ListToolbar,
  RefreshButton,
  Title,
  TopToolbar,
  useNotify,
} from "react-admin";
import { useSelector, useDispatch } from "react-redux";
import { LinearProgress } from "ra-ui-materialui";
import CrewCard from "../../../components/common/CrewCard";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { BackButton } from "../../../components/common/BackButton";
import { logError } from "../../../utils/appUtils";
import {
  InventoryStatus,
  LocationLoadTypeOptions,
  PortalType,
} from "../../../utils/constants";
import {
  getAisleFullName,
  getLocationFullName,
  getLocationViewName,
  isUnmanagedLocation,
} from "../../../utils/locationUtils";
import { LocationInventories } from "./LocationInventories";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  mapContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    flexWrap: "wrap",
    minHeight: theme.spacing(24),
    width: "100%",
  },
  mapContainerMobile: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    flexWrap: "wrap",
    minHeight: theme.spacing(24),
    width: "100%",
  },
  bayContainer: {
    display: "flex",
    flexDirection: "column-reverse",
    alignItems: "center",
    alignContent: "space-between",
    border: "1px solid #b0bec5",
    borderRadius: theme.spacing(1),
    margin: theme.spacing(0.5),
    padding: theme.spacing(0.5),
    paddingTop: theme.spacing(1),
  },
  levelContainer: {
    border: "1px solid",
    borderColor: blueGrey[500],
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  locationAvatar: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: theme.palette.getContrastText(deepOrange[900]),
    backgroundColor: deepOrange[700],
    margin: theme.spacing(0.5),
    whiteSpace: "nowrap",
    border: "1px solid",
    borderColor: deepOrange[500],
    borderRadius: theme.spacing(0.5),
    "&:hover": {
      cursor: "pointer",
      backgroundColor: deepOrange[500],
      color: theme.palette.getContrastText(deepOrange[500]),
    },
    width: "100%",
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  locationAvailableAvatar: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: theme.palette.getContrastText(green[600]),
    backgroundColor: green[600],
    borderColor: green[600],
    margin: theme.spacing(0.5),
    whiteSpace: "nowrap",
    border: "3px solid",
    borderRadius: theme.spacing(0.5),
    "&:hover": {
      cursor: "pointer",
      backgroundColor: green[600],
      color: theme.palette.getContrastText(green[600]),
    },
    width: "100%",
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
}));

const ListActions = ({ init, backPath, ...props }) => {
  return (
    <TopToolbar>
      <RefreshButton onClick={init} />
      <BackButton backPath={backPath} />
    </TopToolbar>
  );
};

export const StructuredAisle = ({ match, history, ...props }) => {
  const classes = useStyles();
  const notify = useNotify();
  const [aisle, setAisle] = useState();
  const [bayList, setBayList] = useState([]);
  const [uomMap, setUomMap] = useState({});
  const [utilization, setUtilization] = useState("");
  const portalType = window.appUser.portalType;
  const backPath = ["/utilization"];
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.data.isLoading);

  useEffect(() => {
    window.scrollTo(0, 0);
    getAisleUtilization();
  }, []);

  const getAisleUtilization = async () => {
    try {
      dispatch({ type: "SET_LOADING", payload: { isLoading: true } });
      debugger;
      const aisleResponse = await API.graphql(
        graphqlOperation(getAisle, { id: match.params.id }),
      );
      const aisle = aisleResponse.data.getAisle;
      if (aisle.locations.nextToken) {
        const locationResponse = await API.graphql(
          graphqlOperation(locationByAisleBySortKey, {
            aisleId: match.params.id,
            limit: 1000,
          }),
        );
        aisle.locations.items =
          locationResponse.data.locationByAisleBySortKey.items.filter(
            (itm) => itm.active === "true",
          );
      } else {
        aisle.locations.items = aisle.locations.items.filter(
          (itm) => itm.active === "true",
        );
      }
      setAisle(aisle);
      setupAisle(aisle);
      const aisleUtilzation =
        aisle.locations.items.reduce(
          (total, itm) => (total += itm.capacityUsed ? itm.capacityUsed : 0),
          0,
        ) / aisle.locations.items.length;
      setUtilization(aisleUtilzation);
      getAisleInventories(aisle);
    } catch (error) {
      logError("StructuredAisle:getAreaUtilization", error, notify);
    } finally {
      dispatch({ type: "SET_LOADING", payload: { isLoading: false } });
    }
  };

  const setupAisle = (aisle) => {
    debugger;
    const bayList = [];

    for (let location of aisle.locations.items) {
      const bay = location.bay;
      if (!bayList[bay]) bayList[bay] = [];
      const level = location.level;
      if (!bayList[bay][level - 1]) bayList[bay][level - 1] = [];
      bayList[bay][level - 1].push(location);
    }
    bayList.splice(0, 1);
    for (let bay of bayList) {
      if (!bay || bay.length === 0) continue;
      for (let level of bay) {
        level.sort((a, b) => {
          return a.position - b.position;
        });
      }
    }
    setBayList(bayList);
  };

  const getAisleInventories = async (aisle) => {
    try {
      dispatch({ type: "SET_LOADING", payload: { isLoading: true } });
      const inventoryItemsList = [];
      const searchInput = {
        aisleId: aisle.id,
        status: { beginsWith: InventoryStatus.STORED },
        limit: 1000,
      };
      let nextToken = true;
      while (nextToken) {
        const input =
          nextToken === true ? searchInput : { ...searchInput, nextToken };
        const results = await API.graphql(
          graphqlOperation(inventoryItemByAisleByStatusLookup, input),
        );
        inventoryItemsList.splice(
          -1,
          0,
          ...results.data.inventoryItemByAisleByStatus.items,
        );
        nextToken = results.data.inventoryItemByAisleByStatus.nextToken;
      }

      if (inventoryItemsList.length > 0) {
        const uomMap = {};
        inventoryItemsList.forEach((itm) => {
          if (!uomMap[itm.inventory.inventoryUOM])
            uomMap[itm.inventory.inventoryUOM] = 0;
          uomMap[itm.inventory.inventoryUOM] += itm.quantityOnHand;
        });
        setUomMap(uomMap);
      }
      debugger;
    } catch (error) {
      logError("utilization:LocationCard:getInventories", error, notify);
    } finally {
      dispatch({ type: "SET_LOADING", payload: { isLoading: false } });
    }
  };

  const handleCancel = () => {
    window.scrollTo(0, 0);
    history.push("/utilization");
  };

  return portalType === PortalType.MANAGER ? (
    <div>
      <Title title={<ForceTitle title="Yard Utilization" />} />
      <ListToolbar
        {...props}
        actions={<ListActions backPath={backPath} init={getAisleUtilization} />}
      />
      <CrewCard title={"Aisle " + getAisleFullName(aisle)} showDivider={false}>
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <AisleContent
          classes={classes}
          notify={notify}
          bayList={bayList}
          uomMap={uomMap}
          utilization={utilization}
          getAisleUtilization={getAisleUtilization}
        />
      </CrewCard>
    </div>
  ) : (
    <CrewCard
      title="Yard Utilization"
      subheader={"Aisle " + getAisleFullName(aisle)}
      showDivider={false}
      icon={<SpeedIcon fontSize="large" />}
      action={
        <IconButton edge="start" onClick={handleCancel}>
          <HighlightOffIcon fontSize="large" />
        </IconButton>
      }
    >
      <>
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <AisleContent
          classes={classes}
          notify={notify}
          bayList={bayList}
          uomMap={uomMap}
          utilization={utilization}
          getAisleUtilization={getAisleUtilization}
        />
        <Grid container xs={12} justifyContent="flex-end">
          <Box>
            <Button onClick={() => handleCancel()} color="default">
              Close
            </Button>
          </Box>
        </Grid>
      </>
    </CrewCard>
  );
};

const AisleContent = ({
  classes,
  notify,
  bayList,
  uomMap,
  utilization,
  getAisleUtilization,
}) => {
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  // const [loadType, setLoadType] = useState();
  // const [totalQuantity, setTotalQuantity] = useState();
  // const [loadTypeName, setLoadTypeName] = useState();
  // const [showQuantity, setShowQuantity] = useState();
  const [inventoryItems, setInventoryItems] = useState([]);
  const [capacityUsed, setCapacityUsed] = useState();
  const [selectedLocation, setSelectedLocation] = useState();
  const [openDialog, setOpenDialog] = useState();
  const dispatch = useDispatch();

  // const [marks, setMarks] = useState(Array.from({length: 6}, (_, i) => ({label: `${i * 20}%`, value: i * 20})));
  // useEffect(() => {
  //     const step = isXSmall ? 20 : 10;
  //     const newMarks = [];
  //     for (let i = 0; i <= 100; i += step) {
  //         newMarks.push({label: `${i}%`, value: i});
  //     }
  //     setMarks(newMarks);
  // }, [isXSmall]);

  const getInventories = async (location) => {
    try {
      debugger;
      dispatch({ type: "SET_LOADING", payload: { isLoading: true } });
      const results = await API.graphql(
        graphqlOperation(inventoryItemByLocationByStatus, {
          locationId: location.id,
          status: { beginsWith: InventoryStatus.STORED },
        }),
      );
      const inventoryItemsList =
        results.data.inventoryItemByLocationByStatus.items;
      if (inventoryItemsList.length > 0) {
        inventoryItemsList.sort((a, b) => b.quantityOnHand - a.quantityOnHand);
        // const loadTypeName = inventoryItemsList[0].inventory.reloadYardCommodity.commodity.locationLoadType.toLowerCase();
        // const sameLoadType = inventoryItemsList.reduce((accumulator, itm) =>
        //     accumulator && itm.inventory.reloadYardCommodity.commodity.locationLoadType === loadTypeName, true);
        // if (sameLoadType && location.locationLoad[loadTypeName].selected) {
        //     setLoadType(location.locationLoad[loadTypeName]);
        //     const totalQuantity = inventoryItemsList.reduce((accumulator, itm) => accumulator + itm.quantityOnHand, 0);
        //     setShowQuantity(true);
        //     setTotalQuantity(totalQuantity);
        //     setLoadTypeName(loadTypeName[0].toUpperCase() + loadTypeName.substring(1));
        // }
      } else {
        // setTotalQuantity(null);
        // setShowQuantity(false);
      }

      setInventoryItems(inventoryItemsList);
      debugger;
    } catch (error) {
      logError("utilization:StructuredAisle:getInventories", error, notify);
    } finally {
      dispatch({ type: "SET_LOADING", payload: { isLoading: false } });
    }
  };

  const handleSelectLocation = async (location) => {
    debugger;
    setSelectedLocation(location);
    setCapacityUsed(location.capacityUsed);
    await getInventories(location);
    setOpenDialog(true);
  };

  const saveLocationCapacity = async () => {
    try {
      debugger;
      const toUpdateLocation = { id: selectedLocation.id, capacityUsed };
      await API.graphql(
        graphqlOperation(updateLocation, { input: toUpdateLocation }),
      );
      getAisleUtilization();
    } catch (err) {
      logError("StructuredAisle:saveLocationCapacity", err, notify);
    } finally {
      setOpenDialog(false);
    }
  };

  const handleCapacityChange = (event, newValue) => {
    debugger;
    setCapacityUsed(newValue);
  };

  const getFullName = (location, size = 16) => {
    if (!location) return "";
    const name = getLocationViewName(location);
    if (!isXSmall) return name;
    if (name.length <= size) return name;
    return name.substring(0, size - 3) + "...";
  };

  const getLocationAvatarClassname = (location) => {
    if (location.capacityUsed === 100) return classes.locationAvatar;
    return classes.locationAvailableAvatar;
  };

  const getLocationCapcity = () => {
    debugger;
    let capacity = "";
    LocationLoadTypeOptions.forEach((item) => {
      const locationLoadType = selectedLocation?.locationLoad[item.id];

      if (locationLoadType?.selected && locationLoadType.capacity) {
        if (capacity === "")
          capacity += `${100 / locationLoadType.capacity} ${item.name}(s)`;
        else
          capacity += `, ${100 / locationLoadType?.capacity} ${item.name}(s)`;
      }
    });

    return capacity;
  };

  // let quantity;
  // if (showQuantity) {
  //     debugger;
  //     quantity = Math.floor(capacityUsed / loadType.capacity);
  // }

  return (
    <Paper elevation={0}>
      <Box mr={2} ml={2} mb={2} justifyContent="center" display="flex">
        <LinearProgress
          color="secondary"
          variant="determinate"
          value={utilization}
          style={{ minWidth: isXSmall ? "80%" : "92%" }}
        />
        &nbsp;{" "}
        {utilization.toLocaleString("en-US", { maximumFractionDigits: 2 })}%
      </Box>
      <Grid container>
        {Object.keys(uomMap).length > 0 && (
          <Grid item xs={12}>
            <Box mb={2}>
              <UomQuantityTable uomMap={uomMap} />
            </Box>
          </Grid>
        )}
        <Grid item xs={12}>
          <div
            className={
              isXSmall ? classes.mapContainerMobile : classes.mapContainer
            }
          >
            {bayList.map((bay, bayIdx) => (
              <div className={classes.bayContainer}>
                <Box m={1}>
                  <Typography>{`Bay ${
                    (bayIdx + 1 < 10 ? " 0" : " ") + (bayIdx + 1)
                  }`}</Typography>
                </Box>
                {bay.map((level) => (
                  <div className={classes.levelContainer}>
                    {level.map((location) => {
                      return (
                        <div
                          key={location.id}
                          className={getLocationAvatarClassname(location)}
                          onClick={() => handleSelectLocation(location)}
                        >
                          <Typography variant="body2">
                            {getFullName(location)}
                          </Typography>
                          <Typography variant="body2">{`${
                            location.capacityUsed ? location.capacityUsed : 0
                          }%`}</Typography>
                        </div>
                      );
                    })}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </Grid>
        <Dialog
          open={openDialog}
          fullWidth
          maxWidth={isXSmall ? "xl" : "md"}
          fullScreen={isXSmall ? true : false}
        >
          <DialogTitle>Change Utilization</DialogTitle>
          <DialogContent>
            <Box mb={2}>
              <Typography variant="subtitle1" gutterBottom>
                Location Capacity
              </Typography>
              {getLocationCapcity()}
            </Box>
            {!selectedLocation?.locationLoad.container.selected ? (
              <Box m={2}>
                <Typography
                  variant="caption"
                  color="textSecondary"
                  gutterBottom
                >
                  {`${getLocationFullName(selectedLocation)} - ${
                    capacityUsed ? capacityUsed : 0
                  }% used`}
                  {/* {showQuantity && ` - ${quantity} ${loadTypeName}`} */}
                </Typography>
                <StructuredCapacitySlider
                  selectedLocation={selectedLocation}
                  capacityUsed={capacityUsed}
                  inventoryItems={inventoryItems}
                  isXSmall={isXSmall}
                  handleCapacityChange={handleCapacityChange}
                />
                {/* <Slider
                                            step={5}
                                            max={100}
                                            value={capacityUsed ? capacityUsed : 0}
                                            onChange={handleCapacityChange}
                                            marks={marks}
                                            fullWidth
                                        /> */}
              </Box>
            ) : (
              <FormControl component="fieldset">
                {/* <FormLabel component="legend">{ `Location ${getLocationFullName(selectedLocation)}`}</FormLabel> */}
                <Typography
                  variant="caption"
                  color="textSecondary"
                  gutterBottom
                >
                  {" "}
                  {`Location ${getLocationFullName(selectedLocation)}`}
                </Typography>
                <RadioGroup
                  name="containerCapacityChange"
                  onChange={(evt) => setCapacityUsed(evt.target.value)}
                  defaultValue={"" + capacityUsed}
                >
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="Empty"
                  />
                  <FormControlLabel
                    value="100"
                    control={<Radio />}
                    label="Full"
                  />
                </RadioGroup>
              </FormControl>
            )}
            <Box mb={2}>
              <Typography variant="subtitle1" gutterBottom>
                Inventories
              </Typography>
              <LocationInventories inventoryItems={inventoryItems} />
              {/* {
                                    showQuantity && <Box mt={1}>
                                        {`Total quantity: ${totalQuantity} ${loadTypeName}`}
                                    </Box>
                                } */}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              onClick={() => setOpenDialog(false)}
              color="default"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              onClick={() => saveLocationCapacity()}
              color="primary"
              autoFocus
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </Paper>
  );
};

const UomQuantityTable = ({ uomMap }) => {
  return (
    <TableContainer>
      <Table size="small" dense>
        <TableHead>
          <TableRow>
            <TableCell>Load type</TableCell>
            <TableCell align="right">Quantity</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.keys(uomMap).map((key) => (
            <TableRow key={key}>
              <TableCell component="th" scope="row">
                {key}
              </TableCell>
              <TableCell align="right">{uomMap[key]}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const StructuredCapacitySlider = ({
  capacityUsed,
  selectedLocation,
  inventoryItems,
  isXSmall,
  handleCapacityChange,
}) => {
  const [marks, setMarks] = useState(
    Array.from({ length: 2 }, (_, i) => ({
      label: `${i * 50}%`,
      value: i * 50,
    })),
  );

  useEffect(() => {
    if (isUnmanagedLocation(selectedLocation)) {
      // locationLoadType = OTHER
      const step = isXSmall ? 20 : 10;
      const steps = 100 / step + 1;
      setMarks(
        Array.from({ length: steps }, (_, i) => ({
          label: `${i * step}%`,
          value: i * step,
        })),
      );
    } else {
      // Extract unique capacities
      const uniqueCapacities = [
        ...new Set(
          inventoryItems
            .map((itm) => {
              const loadTypeName =
                itm.inventory.reloadYardCommodity.commodity.locationLoadType;

              // Check if the locationLoad for the load type is selected and has a capacity
              if (
                selectedLocation.locationLoad[loadTypeName] &&
                selectedLocation.locationLoad[loadTypeName].selected
              ) {
                return selectedLocation.locationLoad[loadTypeName].capacity;
              }

              return null;
            })
            .filter((capacity) => capacity !== null),
        ),
      ];

      const tickSet = new Set([0, 100]);
      let currentCapacity = 0;

      while (currentCapacity < 100) {
        let canAddMore = false;

        for (let capacity of uniqueCapacities) {
          if (currentCapacity + capacity <= 100) {
            currentCapacity += capacity;
            tickSet.add(currentCapacity);
            canAddMore = true;
            break;
          }
        }

        if (!canAddMore) {
          break; // Break if no more load types can be added without exceeding 100%
        }
      }

      const ticks = Array.from(tickSet)
        .sort((a, b) => a - b)
        .map((value) => ({ value, label: `${value}%` }));
      setMarks(ticks);
    }
  }, [selectedLocation, inventoryItems, isXSmall]);

  return (
    <Slider
      value={capacityUsed ? capacityUsed : 0}
      onChange={handleCapacityChange}
      step={null}
      marks={marks}
      max={100}
      fullWidth
    />
  );
};
